import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
const CardLayoutWrapper = ({ to, children, }) => {
    if (!to)
        return children;
    return (_jsx(Link, { target: "_blank", to: to, style: {
            color: 'inherit',
            width: '100%',
            textDecoration: 'none',
            overflow: 'visible',
        }, children: children }));
};
export default CardLayoutWrapper;
